module.exports = __webpack_public_path__ + "assets/shake-glass-max.3d9ad92a.svg";